


















import Vue, { PropType } from 'vue';
import AnnotatedImage from '@/components/correction/AnnotatedImage.vue';
import EssayTextInput from '@/components/EssayTextInput.vue';
import EssayReplyModel from '@/dex-shared/models/EssayReplyModel';
import CorrectionModel from '@/dex-shared/models/CorrectionModel';

export default Vue.extend({
  components: {
    AnnotatedImage,
    EssayTextInput,
  },
  props: {
    essay: {
      type: Object as PropType<EssayReplyModel>,
      required: true,
    },
    correction: {
      type: Object as PropType<CorrectionModel>,
      required: false,
      default: null,
    },
  },
});
